import {
  SPATIAL_ANALYSIS_HIDE_MODAL,
  TEMPORARY_LAYER_MODAL_HIDDEN,
  ADD_TEMPORARY_LAYER_TO_USER_LAYERS,
  TEMPORARY_LAYER_SET_VISIBILITY
} from './mutations.type';

import {
  TEMPORARY_LAYER_ADD,
  SEARCH_LAYER_ADD_OR_EDIT,
  MILEAGE_SEARCH_LAYER_ADD,
  MILEAGE_SEARCH_LAYER_APPEND_FEATURES,
  TERYT_SEARCH_LAYER_ADD,
  TERYT_SEARCH_LAYER_APPEND_FEATURES,
  TEMPORARY_LAYER_SAVE,
  TEMPORARY_LAYER_SAVE_NAME,
  MEASUREMENTS_LAYER_ADD_OR_GET,
  TEMPORARY_LAYER_TOGGLE_VISIBILITY,
  METADATA_EXTENT_LAYER_ADD_OR_CHANGE,
  OTHER_TEMPORARY_LAYER_ADD,
  TEMPORARY_LAYER_REMOVE,
  FETCH_ALL_LAYERS
} from './actions.type';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSONFormat from 'ol/format/GeoJSON';
import { fromExtent } from 'ol/geom/Polygon';
import Feature from 'ol/Feature';
import { transformExtent, get } from 'ol/proj';

import { Api as FilesApi } from '../api/api-pliki';
import { Api as LayersApi } from '../api/api-warstwy';

export const state = {
  layers: [],
  layerNumber: 1,
  geojsonFileInfo: null,
  modalVisible: false,
  layerBeingSaved: null,
  loading: false
};

export const actions = {
  async [TEMPORARY_LAYER_SAVE]({ state, getters, rootGetters }, layer) {
    const layerIndex = rootGetters.layers.indexOf(layer);

    if (layerIndex >= 0) {
      const layerToSave = rootGetters.layers[layerIndex];

      if (!layerToSave.geojson) {
        const features = layerToSave.mapLayer.getSource().getFeatures();
        const geojson = new GeoJSONFormat().writeFeaturesObject(features, {
          featuresProjection: 'EPSG:2180',
          dataProjection: getters.coordinateSystem
        });
        geojson.crs = {
          type: 'name',
          properties: {
            name: 'urn:ogc:def:crs:EPSG::2180'
          }
        };
        layerToSave.geojson = geojson;
      }

      const blob = new Blob([JSON.stringify(layerToSave.geojson)], {
        type: 'application/geo+json'
      });
      const file = new File([blob], 'temporary.geojson');

      try {
        state.loading = true;

        const filesApiResponse = await new FilesApi().postPlikiUzytkownika({
          file: file,
          format: 'geojson',
          kodowanie: 'utf-8'
        });

        state.geojsonFileInfo = filesApiResponse.body;
        state.layerBeingSaved = layerToSave;
        state.modalVisible = true;
      } catch (e) {
      } finally {
        state.loading = false;
      }
    }
  },
  async [TEMPORARY_LAYER_SAVE_NAME](
    { state, dispatch, rootGetters },
    { name, userEmail }
  ) {
    try {
      state.modalVisible = false;
      state.loading = true;

      await new LayersApi().postWarstwyUzytkownika({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        body: {
          nazwa: name,
          kompozycja_id: rootGetters.composition.id,
          ...state.geojsonFileInfo
        }
      });

      dispatch(TEMPORARY_LAYER_REMOVE, state.layerBeingSaved);
      dispatch(FETCH_ALL_LAYERS, { useStoredSettings: true });
    } catch (e) {
    } finally {
      state.loading = false;
    }
  },
  [TEMPORARY_LAYER_ADD](context, geojson) {
    context.commit(ADD_TEMPORARY_LAYER_TO_USER_LAYERS, {
      title: `Warstwa tymczasowa ${state.layerNumber}`,
      visible: true,
      geojson: geojson,
      mapLayer: new VectorLayer({
        source: new VectorSource({
          features: new GeoJSONFormat().readFeatures(geojson)
        }),
        zIndex: Infinity
      }),
      getGeojson() {
        return this.geojson;
      }
    });

    state.layerNumber++;
    context.commit(SPATIAL_ANALYSIS_HIDE_MODAL);
  },
  [SEARCH_LAYER_ADD_OR_EDIT](context, layer) {
    const searchLayerIndex = context.rootGetters.temporaryLayers.findIndex(
      x => x.search
    );

    const formatter = new GeoJSONFormat();
    layer.getGeojson = function() {
      return formatter.writeFeaturesObject(
        this.mapLayer.getSource().getFeatures(),
        {
          featuresProjection: 'EPSG:2180',
          dataProjection: context.rootGetters.coordinateSystem
        }
      );
    };

    if (searchLayerIndex != -1) {
      context.rootGetters.temporaryLayers.splice(searchLayerIndex, 1);
    }

    context.commit(ADD_TEMPORARY_LAYER_TO_USER_LAYERS, layer);
  },
  [MILEAGE_SEARCH_LAYER_ADD](context, layer) {
    const formatter = new GeoJSONFormat();
    layer.getGeojson = function() {
      return formatter.writeFeaturesObject(
        this.mapLayer.getSource().getFeatures(),
        {
          featuresProjection: 'EPSG:2180',
          dataProjection: context.rootGetters.coordinateSystem
        }
      );
    };

    context.commit(ADD_TEMPORARY_LAYER_TO_USER_LAYERS, layer);
  },
  [MILEAGE_SEARCH_LAYER_APPEND_FEATURES](context, features) {
    const layer = context.rootGetters.temporaryLayers.find(
      x => x.mileageSearch == true
    );
    layer.mapLayer.getSource().addFeatures(features);
    const formatter = new GeoJSONFormat();

    layer.getGeojson = function() {
      return formatter.writeFeaturesObject(
        this.mapLayer.getSource().getFeatures(),
        {
          featuresProjection: 'EPSG:2180',
          dataProjection: context.rootGetters.coordinateSystem
        }
      );
    };

    return layer;
  },
  [TERYT_SEARCH_LAYER_ADD](context, layer) {
    const formatter = new GeoJSONFormat();

    layer.getGeojson = function() {
      return formatter.writeFeaturesObject(
        this.mapLayer.getSource().getFeatures(),
        {
          featuresProjection: 'EPSG:2180',
          dataProjection: context.rootGetters.coordinateSystem
        }
      );
    };

    context.commit(ADD_TEMPORARY_LAYER_TO_USER_LAYERS, layer);
  },
  [TERYT_SEARCH_LAYER_APPEND_FEATURES](context, features) {
    const layer = context.rootGetters.temporaryLayers.find(
      x => x.terytSearch == true
    );
    layer.mapLayer.getSource().addFeatures(features);
    const formatter = new GeoJSONFormat();
    layer.getGeojson = function() {
      return formatter.writeFeaturesObject(
        this.mapLayer.getSource().getFeatures(),
        {
          featuresProjection: 'EPSG:2180',
          dataProjection: context.rootGetters.coordinateSystem
        }
      );
    };
    return layer;
  },
  [MEASUREMENTS_LAYER_ADD_OR_GET]({ rootGetters, commit }) {
    const measurementLayer = rootGetters.temporaryLayers.find(
      l => l.measurement
    );

    if (measurementLayer) {
      if (!measurementLayer.visible) {
        measurementLayer.visible = true;
      }

      return measurementLayer;
    }

    const formatter = new GeoJSONFormat();

    const layer = {
      title: 'Warstwa pomiarowa',
      visible: true,
      measurement: true,
      mapLayer: new VectorLayer({
        source: new VectorSource(),
        zIndex: Infinity
      }),
      getGeojson() {
        return formatter.writeFeaturesObject(
          this.mapLayer.getSource().getFeatures(),
          {
            featuresProjection: 'EPSG:2180',
            dataProjection: rootGetters.coordinateSystem
          }
        );
      }
    };

    commit(ADD_TEMPORARY_LAYER_TO_USER_LAYERS, layer);

    return layer;
  },
  [METADATA_EXTENT_LAYER_ADD_OR_CHANGE]({ rootGetters, commit }, extent) {
    const formatter = new GeoJSONFormat();
    const transformedExtent = transformExtent(
      extent,
      get('EPSG:4326'),
      get('EPSG:2180')
    );
    const extentFeature = new Feature(fromExtent(transformedExtent));

    const layer = {
      title: 'Zasięg m.p.z.p.',
      visible: true,
      metadata: true,
      extent: transformedExtent,
      zoomed: false,
      mapLayer: new VectorLayer({
        source: new VectorSource({ features: [extentFeature] }),
        zIndex: Infinity
      }),
      getGeojson() {
        return formatter.writeFeaturesObject(
          this.mapLayer.getSource().getFeatures(),
          {
            featuresProjection: 'EPSG:2180',
            dataProjection: rootGetters.coordinateSystem
          }
        );
      }
    };

    const metadataExtentLayerIndex = rootGetters.temporaryLayers.findIndex(
      l => l.metadata
    );

    if (metadataExtentLayerIndex > -1) {
      rootGetters.temporaryLayers.splice(metadataExtentLayerIndex, 1, layer);
    } else {
      commit(ADD_TEMPORARY_LAYER_TO_USER_LAYERS, layer);
    }

    return layer;
  },
  [TEMPORARY_LAYER_TOGGLE_VISIBILITY](_, layer) {
    layer.visible = !layer.visible;
  },
  [OTHER_TEMPORARY_LAYER_ADD](context, payload) {
    context.commit(ADD_TEMPORARY_LAYER_TO_USER_LAYERS, {
      title: payload.title,
      visible: true,
      mapLayer: payload.mapLayer
    });

    state.layerNumber++;
  }
};

export const mutations = {
  [TEMPORARY_LAYER_MODAL_HIDDEN]() {
    state.modalVisible = false;
  },
  [TEMPORARY_LAYER_SET_VISIBILITY](_, { layer, visible }) {
    layer.visible = visible;
  }
};

export const getters = {
  temporaryLayerGeojsonFileData() {
    return state.geojsonFileInfo;
  },
  temporaryLayerSaveModalVisibility() {
    return state.modalVisible;
  },
  temporaryLayersModuleLoading: state => state.loading
};

export default {
  state,
  actions,
  mutations,
  getters
};
